import CollectiblesListSmall, { Props } from "@organisms/collectibles-list-small";

const AirdropCollectibles = ({ ...props }: Props) => {
  return <CollectiblesListSmall {...props} />;
};

export default AirdropCollectibles;
